module.exports = __webpack_public_path__ + "img/Mosul_Thumb.ccafdfc5.jpg";